export default "__VITE_ASSET__iOCzIEoZ__"